<template>
  <div @mouseenter="isTaskOptionsButtonShown = true" @mouseleave="isTaskOptionsButtonShown = false">
    <b-row>
      <b-col class="col-1 mt-3 center-align-icon">
        <font-awesome-icon v-if="!taskDetails.completed" class="task-completed-toggle" :icon="['far', 'circle']" @click="toggleTaskCompleted"/>
        <font-awesome-icon v-else class="task-completed-toggle" :icon="['fas', 'check-circle']" @click="toggleTaskCompleted"/>
      </b-col>
      <b-col class="task-details-click-area" @click="showTaskDetailsModal">
        <p class="task-name-text" :class="{'completed-task-text': taskDetails.completed}">{{ taskDetails.taskName }}</p>
        <p class="task-description-text" :class="{'completed-task-origin': taskDetails.completed}">Origin: {{ taskDetails.toDoListName }}</p>
      </b-col>
      <b-col class="col-1 mt-3 center-align-icon">
        <font-awesome-icon v-if="taskDetails.priority === 0" class="task-priority-icon" icon="exclamation" @click="showTaskDetailsModal"/>
        <font-awesome-icon v-else-if="taskDetails.priority === 2" class="task-priority-icon" icon="arrow-down"
                           @click="showTaskDetailsModal"/>
      </b-col>
      <b-col class="col-1 mt-3 mr-4 center-align-icon">
        <font-awesome-icon v-if="isTaskOptionsButtonShown" class="task-option-button" :icon="['far', 'edit']" @click="showTaskDetailsModal"/>
      </b-col>
    </b-row>
    <hr>

    <!-- Task Details Modal -->
    <b-modal
        id="task-details-modal"
        :title="taskDetailsModalTitle"
        :visible="isTaskDetailsModalShown"
        @hide="isTaskDetailsModalShown = false"
        scrollable
        no-close-on-backdrop
        hide-footer>
      <personal-task-details v-if="taskDetails.taskType === 'Personal Task'" :personal-task-details="taskDetails"></personal-task-details>
      <collaborative-task-details v-if="taskDetails.taskType === 'Collaborative Task'" :collaborative-task-details="taskDetails"></collaborative-task-details>
    </b-modal>

    <!-- Task Options Modal -->
    <b-modal
        id="delete-task-modal"
        title="Delete Task"
        :visible="isDeleteTaskModalShown"
        @hide="isDeleteTaskModalShown = false"
        scrollable
        ok-only
        ok-title="Delete task"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="delete-task-text">Are you sure do you want to delete <strong>"{{ taskDetails.taskName }}"</strong> from the list?</p>
    </b-modal>
  </div>
</template>

<script>
  import PersonalTaskDetails from "../../task_details_templates/PersonalTaskDetails"
  import CollaborativeTaskDetails from "../../task_details_templates/CollaborativeTaskDetails"
  import {db} from "../../../main";

  export default {
    name: "CollaborativeTaskCell",
    props: {
      taskDetails: Object
    },
    components: {
      personalTaskDetails: PersonalTaskDetails,
      collaborativeTaskDetails: CollaborativeTaskDetails
    },
    data() {
      return {
        isTaskOptionsButtonShown: false,
        isTaskDetailsModalShown: false,
        taskDetailsModalTitle: '',
        isDeleteTaskModalShown: false
      }
    },
    methods: {
      showTaskDetailsModal() {
        this.isTaskDetailsModalShown = true
        if (this.taskDetails.taskType === 'Personal Task') {
          this.taskDetailsModalTitle = 'Personal Task Details'
        } else if (this.taskDetails.taskType === 'Collaborative Task') {
          this.taskDetailsModalTitle = 'Collaborative Task Details'
        }
      },
      toggleTaskCompleted() {
        const updatedStatus = !this.taskDetails.completed

        if (this.taskDetails.taskType === 'Personal Task') {
          if (this.taskDetails.inboxTask) {
            db.collection('inbox_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
              .doc(this.taskDetails.taskId)
              .update('completed', updatedStatus)
          } else {
            db.collection('personal_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
              .doc(this.taskDetails.taskId)
              .update('completed', updatedStatus)
          }
        } else if (this.taskDetails.taskType === 'Collaborative Task') {
          db.collection('collaborative_to_do_lists/' + this.taskDetails.toDoListId + '/tasks')
            .doc(this.taskDetails.taskId)
            .update('completed', updatedStatus)
        }
      }
    }
  }
</script>

<style scoped>
  .center-align-icon {
    text-align: center;
  }

  .task-completed-toggle {
    font-size: 1.5em;
  }

  .task-completed-toggle:hover {
    cursor: pointer;
  }

  .completed-task-text {
    text-decoration: line-through;
    color: gray;
  }

  .completed-task-origin {
    color: gray;
  }

  .task-priority-icon {
    font-size: 1.5em;
  }

  .task-name-text {
    margin-bottom: 0.5em;
  }

  .task-description-text {
    font-size: 0.9em;
    margin-bottom: 0;
  }

  .task-details-click-area {
    cursor: pointer;
  }

  .task-option-button {
    margin-right: 1.5em;
  }

  .task-option-button:hover {
    cursor: pointer;
  }

  .delete-task-text {
    margin-bottom: 0;
  }
</style>
